import { createStore, applyMiddleware } from 'redux';
import {combineReducers} from 'redux';
import { routerReducer } from 'react-router-redux';

// middleware
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import sessionGlobalMiddleware from './redux-middleware/session-global-middleware';

// Import controllers whose state needs to be managed by redux.
import { updateSubStateFromAction as openReturnsSubStateUpdater } from './controllers/openReturns';
import { updateSubStateFromAction as filingSubStateUpdater } from './controllers/filing';
import { updateSubStateFromAction as filingCorrectionsSubStateUpdater } from './controllers/filingCorrections';
import { updateSubStateFromAction as filingMetaDataSubStateUpdater } from './controllers/filingMetaData';
import { updateSubStateFromAction as userQuestionsSubStateUpdater } from './controllers/userQuestions';
import { updateSubStateFromAction as filingOptionsSubStateUpdater } from './controllers/filingOptions';
import { updateSubStateFromAction as fileSubStateUpdater } from './controllers/files';
import { updateSubStateFromAction as companySubStateUpdater } from './controllers/companies';
import { updateSubStateFromAction as languageSubStateUpdater } from './controllers/languages';
import { updateSubStateFromAction as authenticationSubStateUpdater } from './controllers/authentication';
import { updateSubStateFromAction as navigationMenuVisibilitySubStateUpdater } from './controllers/navigationMenuVisibility';
import { updateSubStateFromAction as contentSubStateUpdater } from './controllers/content';
import { updateSubStateFromAction as commentSubStateUpdater } from './controllers/comments';
import { updateSubStateFromAction as userSubStateUpdater } from './controllers/users';
import { updateSubStateFromAction as documentSubStateUpdater } from './controllers/documents';
import { updateSubStateFromAction as uploadedDocumentsSubStateUpdater } from './controllers/uploadedDocuments';
import { updateSubStateFromAction as errorsWarningsSubStateUpdater } from './controllers/errorsWarnings';
import { updateSubStateFromAction as managedUxFormsSubStateUpdater } from './controllers/managedUxForms';
import { updateSubStateFromAction as accountSettingsSubStateUpdater } from './controllers/accountSettings';
import { updateSubStateFromAction as vatGroupSubStateUpdater } from './controllers/vatGroups';
import { updateSubStateFromAction as errorDocumentDetailSubStateUpdater } from './controllers/errorDocumentDetail';
import { updateSubStateFromAction as vatNumbersSubStateUpdater} from './controllers/vatNumbers';
import Logger, { updateSubStateFromAction as loggerSubStateUpdater } from './utils/logger';
import { updateSubStateFromAction as transactionSearchSubStateUpdater } from './controllers/transactions';
import { updateSubStateFromAction as liveReportingSubStateUpdater } from './controllers/liveReporting';
import { updateSubStateFromAction as closedReturnsSubStateUpdater } from './controllers/closedReturns';
import { updateSubStateFromAction as transactionSubStateUpdater } from './controllers/transactionEdit';
import { updateSubStateFromAction as vatCodesSubStateUpdater } from './controllers/vatCodes';
import { updateSubStateFromAction as vatCodeSimulatorSubStateUpdater } from './controllers/vatCodeSimulator';
import { updateSubStateFromAction as dataMiningSubStateUpdater } from './controllers/dataMining';
import {updateSubStateFromAction as analysisSubStateUpdater} from './controllers/analysis';
import {updateSubStateFromAction as manualDocumentsSubStateUpdates} from './controllers/manualDocuments';
import { updateSubStateFromAction as ukMTDVATSubStateUpdater } from './controllers/ukMTDVAT';
import { updateSubStateFromAction as exchangeRatesSubStateUpdater } from './controllers/exchangeRates';
import { updateSubStateFromAction as filingTransactionsSubStateUpdater } from './controllers/vatReturnByTransactions';
import { updateSubStateFromAction as searchByDetailsFormSubStateUpdater } from './controllers/vatCodeSearch';
import { updateSubStateFromAction as processingStatsSubStateUpdater } from './controllers/processingStats';
import { updateSubStateFromAction as countriesOnHoldSubStateUpdater } from './controllers/countriesOnHold';
import { updateSubStateFromAction as salesAndPurchaseSubStateUpdater } from './controllers/salesAndLedgers';
import { updateSubStateFromAction as dynamicReportsSubStateUpdater } from './controllers/dynamicReports';
import { updateSubStateFromAction as featureFlagSubStateUpdater } from './controllers/featureFlag';
import { updateSubStateFromAction as returnApprovalsSubStateUpdater } from './controllers/returnApprovals';
import sessionReducer, { sessionPromiseReducer } from './controllers/session';
import { userManagementReducer } from './controllers/userManagement';
import { bulkActionReducer } from './controllers/bulkAction';
import { bulkActionStatusReducer } from './controllers/bulkActionStatus';
import { companyPermissionsReducer } from './controllers/companyPermissions';
import { directSubmissionPermissionsReducer } from './controllers/directSubmissionPermissions';
import { updateSubStateFromAction as iamUsersSubStateUpdater } from './controllers/iamUsers';

const createHistory = require("history").createBrowserHistory;

export const globalAppState = combineReducers(
  {
    errorDetail: errorDocumentDetailSubStateUpdater,
    accountSettings: accountSettingsSubStateUpdater,
    analysis: analysisSubStateUpdater,
    content: contentSubStateUpdater,
    authentication: authenticationSubStateUpdater,
    navigationMenuVisibility: navigationMenuVisibilitySubStateUpdater,
    languages: languageSubStateUpdater,
    files: fileSubStateUpdater,
    filing: filingSubStateUpdater,
    filingCorrections: filingCorrectionsSubStateUpdater,
    filingMetaData: filingMetaDataSubStateUpdater,
    filingOptions: filingOptionsSubStateUpdater,
    openReturns: openReturnsSubStateUpdater,
    userQuestions: userQuestionsSubStateUpdater,
    companies: companySubStateUpdater,
    vatGroups: vatGroupSubStateUpdater,
    comments: commentSubStateUpdater,
    users: userSubStateUpdater,
    documents: documentSubStateUpdater,
    uploadedDocuments: uploadedDocumentsSubStateUpdater,
    errorsWarnings: errorsWarningsSubStateUpdater,
    managedUxForms: managedUxFormsSubStateUpdater,
    vatNumbers: vatNumbersSubStateUpdater,
    logger: loggerSubStateUpdater,
    transactionSearch: transactionSearchSubStateUpdater,
    liveReporting: liveReportingSubStateUpdater,
    router: routerReducer,
    closedReturns: closedReturnsSubStateUpdater,
    transaction: transactionSubStateUpdater,
    vatCodes: vatCodesSubStateUpdater,
    vatCodeSimulator: vatCodeSimulatorSubStateUpdater,
    dataMining :  dataMiningSubStateUpdater,
    manualDocuments: manualDocumentsSubStateUpdates,
    ukMTDVAT : ukMTDVATSubStateUpdater,
    exchangeRates: exchangeRatesSubStateUpdater,
    filingTransactions: filingTransactionsSubStateUpdater,
    searchByDetailsForm: searchByDetailsFormSubStateUpdater,
    processingStats: processingStatsSubStateUpdater,
    countriesOnHold: countriesOnHoldSubStateUpdater,
    session: sessionReducer,
    sessionPromise: sessionPromiseReducer,
    userManagement: userManagementReducer,
    bulkAction: bulkActionReducer,
    bulkActionStatus: bulkActionStatusReducer,
    salesAndPurchaseLedger: salesAndPurchaseSubStateUpdater,
    dynamicReports: dynamicReportsSubStateUpdater,
    featureFlag: featureFlagSubStateUpdater,
    returnApprovals: returnApprovalsSubStateUpdater,
    companyPermissions: companyPermissionsReducer,
    directSubmissionPermissions: directSubmissionPermissionsReducer,
    iamUsers: iamUsersSubStateUpdater
  }
);

export const browserHistory = createHistory();

export default function initialise(initialState) {
  const reduxMiddleware = applyMiddleware(
    thunkMiddleware, 
    routerMiddleware(browserHistory),
    sessionGlobalMiddleware,
  );
  const store = createStore(
    globalAppState,
    initialState,
    reduxMiddleware
  );
  Logger.setDispatcher(store.dispatch);
  return store;
}
